
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('circle',{attrs:{"cx":"256","cy":"256","r":"256"}})])]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"fill":"#032ea1","d":"M0 0h512v512H0z"}}),_c('path',{attrs:{"fill":"#e00025","d":"M0 128h512v256H0z"}}),_c('path',{attrs:{"d":"M328.7 296.2H183.3v-8.7c0-3.3 2.7-6.1 6.1-6.1h7.8v-20.9h-8.7c-3.3 0-6.1-2.7-6.1-6.1v-8.7c0-3.3 2.7-6.1 6.1-6.1h13.9v-13c0-3.3 2.7-6.1 6.1-6.1h8.7c3.3 0 6.1 2.7 6.1 6.1v13h23.5v-27.8c0-3.3 2.7-6.1 6.1-6.1h8.7c3.3 0 6.1 2.7 6.1 6.1v27.8h23.5v-13c0-3.3 2.7-6.1 6.1-6.1h8.7c3.3 0 6.1 2.7 6.1 6.1v13H326c3.3 0 6.1 2.7 6.1 6.1v8.7c0 3.3-2.7 6.1-6.1 6.1h-8.7v20.9h7.8c3.3 0 6.1 2.7 6.1 6.1v8.7z","fill":"#fff"}})])])
          )
        }
      }
    